import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { StyledCellWrapper } from '@urc-ui/components/styles';
import { Text } from '@amzn/storm-ui-v3';

export function CovCellRenderer(props: ICellRendererParams) {
  const cov = props.value;
  if (!cov) {
    return (
      <StyledCellWrapper>
        <Text fontSize='small'>&#8212;</Text>
      </StyledCellWrapper>
    );
  }
  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{cov}</Text>
    </StyledCellWrapper>
  );
}
